export default "__VITE_ASSET__BREZPO95__"